import { EventEmitter, Injectable, Output, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { cvAssignmentToolGroupItem, CxRoleModel, LoginApiModel, ProfileModel } from 'src/app/reusables/assign-tool/angular-assign-tool/angular-assign-tool.models';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { DashboardAccessOptions, DashboardResponsiveApiModel, DashboardResponsiveApiModelSparse } from 'src/shared/models/dashboard.model';
import { AccessChanges, AccessChangesDTO } from './dashboard-access.model';
import { ModalService } from '@niceltd/sol/modal';

@Injectable({
    providedIn: 'root'
})
export class DashboardAccessService {

    @Output() modalClosed: EventEmitter<void> = new EventEmitter();

    private modalData: DashboardAccessOptions = null;

    constructor(
        private cvApiService: CVApiService,
        private solModalService: ModalService
    ) { }

    public openModal(options: DashboardAccessOptions, modalComponent: Type<any>) {
        if (!options || typeof options !== "object")
            throw Error("Options argument is required");

        this.modalData = options;

        const modalRef = this.solModalService.open(modalComponent, {
            data: options,
            backdrop: 'static',
            disableClose: true,
            width: '540px',
        });

        return modalRef;
    }

    public _getModalData(): DashboardAccessOptions {
        const modalData = this.modalData;
        this.modalData = null;
        return modalData;
    }

    public async loadTeams() {
        try {
            const teamsURL = "/api/v1/emp_groups/2";
            const response = await this.cvApiService.get<cvAssignmentToolGroupItem[]>(teamsURL);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            }
            else {
                throw response;
            }
        } catch (err) {
            console.error("Failed getting teams data for dashboard access modal");
            throw err;
        }
    }

    public async loadAgents() {
        try {
            const agentsURL = "/api/v1/logins";
            const response = await this.cvApiService.get<LoginApiModel[]>(agentsURL);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        } catch (err) {
            console.error("Failed getting agent data for dashboard access modal");
            throw err;
        }
    }

    public async UpdateDashboardsAccesses(dashboardKeys: string[], queuedChanges: AccessChanges, isPublic: boolean = false) {
        const url = `/api/v2/shared-dashboards/update`;

        const data = new Array<AccessChangesDTO>();

        try {
            queuedChanges.logins.forEach(l => {
                data.push({
                    isLogin: true,
                    id: l.login.LoginID,
                    permission: l.permission
                });
            });

            queuedChanges.groups.forEach(g => {
                g.profiles.forEach(p => {
                    data.push({
                        isLogin: false,
                        id: p.profile.ProfileID,
                        permission: p.permission,
                        companyID: g.group.CompanyID,
                        groupID: g.group.GroupID,
                        groupLevel: g.group.GroupLevel,
                        baseGroupType: g.group.BaseGroupType
                    });
                });
            });

            const response = await this.cvApiService.post(url, {
                dashboardKeys,
                changes: data,
                isPublic
            });
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error("Failed updating assignment for one or more dashboards.");
            throw err;
        }
    }

    public async loadRoles() {
        try {
            const url = `/api/v1/roles`;
            const response = await this.cvApiService.get<[ProfileModel[]]>(url);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        } catch (err) {
            console.error("Failed loading roles for dashboard access modal");
            throw err;
        }

    }

    public async loadCxoneRoles() {
        try {
            const url = `/api/v1/cxone-roles`;
            const response = await this.cvApiService.get<CxRoleModel[]>(url);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } else {
                throw response;
            }
        } catch (err) {
            console.error("Failed loading roles for dashboard access modal");
            throw err;
        }
    }
}
